{
    "LinkInput_Title": "Titel",
    "LinkInput_URL": "URL",
    "LinkInput_Target": "Doel",
    "LinkInput_NewTab": "Openen in nieuw tabblad",
    "LinkInput_CurrentTab": "Openen in huidig tabblad",
    "NAME": "LinkInputLanguage"
}